import PartialSuccessIcon from "./PartialSuccessIcon";
import PartialFailureicon from "./PartialFailureicon";
import PartialLoading from "./PartialLoading";
import PartialBookLoading from "./PartialBookLoading";
import PartialImportExcel from "./PartialImportExcel";

const Partials = {
    PartialSuccessIcon,
    PartialFailureicon,
    PartialLoading,
    PartialBookLoading,
    PartialImportExcel
}

export default Partials;
